import { render, staticRenderFns } from "./SlidersForm.vue?vue&type=template&id=3eb9568d&"
import script from "./SlidersForm.vue?vue&type=script&lang=js&"
export * from "./SlidersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports